import { WidgetRegistryEntry } from "@smallstack/widget-core";

export const WorklogLikeTimerWidget: WidgetRegistryEntry = {
  name: "WorklogLikeTimer",
  component: () => import("./worklog-like-timer-widget.component").then((m) => m.WorklogLikeTimerWidgetComponent),
  configuration: () => import("./configuration").then((m) => m.WorklogLikeTimerWidgetConfiguration)
};
